import React from 'react';
import { Box, Typography } from '@mui/material';

export interface RegulatoryHeaderProps {
  title: string; // e.g., Bilan
  entity: string; // Nom de l'entité
  systemLabel: string; // SN / SMT
  currency: string; // e.g., XOF / EUR
  periodText: string; // e.g., Exercice du 01/01/2024 au 31/12/2024
}

interface Props extends RegulatoryHeaderProps {
  children: React.ReactNode;
}

const RegulatorySheet: React.FC<Props> = ({ title, entity, systemLabel, currency, periodText, children }) => {
  return (
    <Box sx={{
      bgcolor: '#fff',
      color: '#000',
      border: '3px solid #000',
      p: 2,
      mb: 3,
      boxShadow: 'none',
      '@media print': {
        m: 0,
        borderColor: '#000',
      },
    }}>
      {/* Header */}
      <Box sx={{ textAlign: 'center', mb: 1 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 800, textTransform: 'uppercase', letterSpacing: 0.5 }}>
          {entity || 'Entité EBNL'}
        </Typography>
        <Typography variant="subtitle1" sx={{ fontWeight: 900, textTransform: 'uppercase', letterSpacing: 0.6, mt: 0.5 }}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ fontStyle: 'italic', mt: 0.5 }}>
          {periodText}
        </Typography>
        <Typography variant="caption" sx={{ display: 'block', mt: 0.5 }}>
          Système: {systemLabel} • Devise: {currency || 'XOF'}
        </Typography>
      </Box>

      {/* Title band */}
      <Box sx={{
        backgroundColor: '#f2f2f2',
        borderTop: '2px solid #000',
        borderBottom: '2px solid #000',
        py: 0.5,
        textAlign: 'center',
        mb: 1.5,
      }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 800, letterSpacing: 0.4, textTransform: 'uppercase' }}>{title}</Typography>
      </Box>

      {/* Content */}
      <Box sx={{
        border: '2px solid #000',
        p: 0,
        '@media print': { borderWidth: '2px' },
      }}>
        {children}
      </Box>

      {/* Footer spacing (signatures, mentions) */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
        <Typography variant="caption" sx={{ opacity: 0.9 }}>Le Responsable</Typography>
        <Typography variant="caption" sx={{ opacity: 0.9 }}>Fait à .........., le ......./....../..........</Typography>
        <Typography variant="caption" sx={{ opacity: 0.9 }}>Le Comptable</Typography>
      </Box>
    </Box>
  );
};

export default RegulatorySheet;